<template>
    <TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
                @deploy:live="$emit('deploy:live')">
        <v-container fluid>
            <v-row justify="center">
                <v-col cols="12" lg="10">
                    <Textarea label="Notizen" v-model.trim="note" :disabled="readOnly"></Textarea>
                </v-col>
            </v-row>
        </v-container>
    </TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Textarea from "../../../components/Inputs/Textarea";

export default {
    name: "Notes",
    components: {Textarea, TabWrapper},
    props: ['readOnly'],
    data: () => {
        return {
            note: ''
        }
    },
    mounted() {
        this.init();
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        activeTab() {
            return this.vuexState.activeTab;
        }
    },
    methods: {
        init() {
            if (this.siteDetails) {
                this.note = this.siteDetails.Current.Note;
            }
        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.vuexState.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            } else if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        },
        dataChanged() {
            let changed = false;
            if (this.note !== this.siteDetails.Current.Note) {
                changed = true;
            }
            return changed;
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                Note: this.note
            }
        },
    },
    watch: {
        siteDetails() {
            this.init();
        }
    }
}
</script>

<style scoped>

</style>